import { tokenPrefix } from '../../common';
import { HttpError, SessionClosedError, SessionConflictError } from '../errors';


export interface AdyenSessionResponse {
    id: string
    expires_at: string
    session_data: string
}

export interface AdyenClaimSessionResponse {
    status: string
}

export interface AdyenSessionResultResponse {
    customer_credit_card_id: string
}

export class InternalAdyenSessionsApiClient {

    constructor(private readonly host: string, private token: string) { }


    private async post(url: string, body: Record<string, any> | string, headers?: Record<string, string>): Promise<any> {
        const method = 'POST';
        const defaultHeaders = {
            'Content-Type': 'application/json',
            "Authorization": `${tokenPrefix} ${this.token}`,
        }
        const requestHeaders = headers ?? defaultHeaders
        const response = await fetch(url, {
            method: method,
            headers: requestHeaders,
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new HttpError(`HTTP error - status: ${response.status}`, response.status);
        }

        const payload = await response.json();
        return payload;
    }

    async createAdyenSession(
        encodedSessionData: string
    ): Promise<AdyenSessionResponse> {
        const endpoint = 'adyen/adyen-session/';
        const response = await this.post(`${this.host}/${endpoint}`, {
            session_data: encodedSessionData
        });
        return response;
    }

    async createAdyenTokenizationSession(
        encodedSessionData: string
    ): Promise<AdyenSessionResponse> {
        const endpoint = 'adyen/tokenization-sessions/';
        const response = await this.post(`${this.host}/${endpoint}`,
            { session_data: encodedSessionData }, { 'Content-Type': 'application/json' });
        return response;
    }

    async claimSession(sessionId: string): Promise<AdyenClaimSessionResponse> {
        const endpoint = 'adyen/adyen-session-claim/';
        try {
            const response = await this.post(`${this.host}/${endpoint}`, {
                session_id: sessionId,
            });

            return response;
        } catch (error) {
            if (error instanceof HttpError && error.status === 409) {
                throw new SessionConflictError(`Someone else is currently paying the transaction.`);
            }
            if (error instanceof HttpError && error.status === 410) {
                throw new SessionClosedError(`The payment has already been paid.`);
            }
            throw error;
        }
    }

    async sendAdyenSessionResult(
        brand: string,
        endDigits: string,
        contactId: string,
        transactionId: string,
        resultCode: string,
        sessionId: string
    ): Promise<AdyenSessionResultResponse> {
        const endpoint = 'adyen/adyen-session-result/';
        const response = await this.post(`${this.host}/${endpoint}`, {
            brand: brand,
            end_digits: endDigits,
            contact_id: contactId,
            transaction_id: transactionId,
            result_code: resultCode,
            session_id: sessionId,
        });
        return response;
    }
}

